import { supabase } from "./lib/supabase";
import type { PublicVehicleCatalogData } from "./PublicVehicleCatalog";

export type PublicSiteCapabilities = {
  financing: boolean;
  newsletter: boolean;
  favorites: boolean;
  comparison: boolean;
  account: boolean;
  vehicle_capture: boolean;
};

export type UnifiedPublicSiteSnapshot<TStand = Record<string, unknown>> = {
  contract_version: "1.0.0";
  revision_id: string | null;
  revision_number?: number;
  template_version_id: string;
  published_at?: string;
  preview?: boolean;
  stand: TStand;
  catalog: PublicVehicleCatalogData;
  vehicles: PublicVehicleCatalogData["vehicles"];
  vehicle_details: unknown[];
  capabilities: PublicSiteCapabilities;
  legal: { privacy: boolean; cookies: boolean; terms: boolean };
  pages: unknown[];
  cache?: { etag: string; immutable: boolean; generated_at: string };
};

export async function readPublicSiteSnapshot<TStand>(slug: string) {
  const { data, error } = await supabase.rpc("read_public_stand_site", { p_slug: slug });
  if (error || !data) {
    throw error ?? new Error("Site público não disponível.");
  }
  return data as UnifiedPublicSiteSnapshot<TStand>;
}
